import "@/App.css";
import AIChatWidget from "@/components/AIChatWidget";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { LanguageProvider } from "@/contexts/LanguageContext";
import Home from "@/pages/Home";
import ToniniBitlab from "@/pages/ToniniBitlab";
import NasaMyner from "@/pages/NasaMyner";
import AIChatPage from "@/pages/AIChatPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/tonini-bitlab" element={<ToniniBitlab />} />
            <Route path="/nasa-myner" element={<NasaMyner />} />
            <Route path="/asistent" element={<AIChatPage />} />
          </Routes>
        </BrowserRouter>
        <AIChatWidget />
      </LanguageProvider>
    </div>
  );
}

export default App;
